import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';
import { setSearchTerm } from '@actions/search';
import Section from '@components/Section';
import styles from './Interests.module.scss';
import Contact from '@models/Contact';

export default function Interests({
  contact,
  clickable = true,
  underline = true,
}: {
  contact: Contact;
  clickable?: boolean;
  underline?: boolean;
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const searchForInterest = (interest: string, e: MouseEvent) => {
    e.preventDefault();

    if (clickable) {
      dispatch(setSearchTerm(interest.toLowerCase(), true));
      navigate('/search');
    }
  };

  return (
    (contact.interests?.length || 0) > 0 && (
      <Section>
        <Section.Title underline={underline}>Interests</Section.Title>
        <div className={styles.container}>
          {contact.interests.map((interest, i) => (
            <a
              href="#"
              onClick={searchForInterest.bind(null, interest.n)}
              className={cn(styles.interest, !clickable && styles.notClickable)}
              key={i}
            >
              {interest.n}
            </a>
          ))}
        </div>
      </Section>
    )
  );
}
